import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { COMPARE_MAX } from "../lib/compare";

// T50: "What is compare?" helper next to every Add to compare control. Radix Dialog = focus trap + Esc; bottom sheet on phones.
export function CompareHelp({ testid = "compare-help", className = "" }) {
  const [open, setOpen] = useState(false);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  return (
    <>
      <button type="button" aria-label="What is compare?" title="What is compare?" data-testid={testid}
        onClick={(e) => { stop(e); setOpen(true); }}
        className={`inline-flex items-center justify-center rounded-full text-slate-500 hover:text-[var(--brand-primary)] focus-visible:outline focus-visible:outline-2 ${className}`}>
        <HelpCircle size={16} aria-hidden="true" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="compare-help-modal" onClick={(e) => e.stopPropagation()}
          className="rs-compare-help max-w-md">
          <DialogTitle>What is compare?</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 text-sm text-slate-700">
              <p>Compare shows products side by side, so you can check price, key specs and stock at a glance.</p>
              <div><b className="text-slate-900">How to use it</b>
                <ol className="mt-1 list-decimal pl-5 space-y-1">
                  <li>Tick <b>Add to compare</b> on up to {COMPARE_MAX} products.</li>
                  <li>They collect in the compare bar at the bottom of the screen.</li>
                  <li>Choose <b>Compare</b> in the bar to open them side by side.</li>
                </ol></div>
              <div><b className="text-slate-900">Removing items</b>
                <p className="mt-1">Tap the tick again, use the × next to a product in the compare bar, or clear them all from the bar.</p></div>
              <p className="text-slate-500">Your selection is kept on this device, so it's still there when you come back.</p>
            </div>
          </DialogDescription>
          <button type="button" data-testid="compare-help-close" onClick={() => setOpen(false)}
            className="mt-2 w-full min-h-[44px] rounded-full bg-[var(--brand-primary)] font-semibold text-white">Got it</button>
        </DialogContent>
      </Dialog>
    </>
  );
}
